import { render, staticRenderFns } from "./viewPMR.vue?vue&type=template&id=09d4e9e1&"
import script from "./viewPMR.vue?vue&type=script&lang=js&"
export * from "./viewPMR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports